import { render, staticRenderFns } from "./DetailError.vue?vue&type=template&id=d077bf6e"
import script from "./DetailError.vue?vue&type=script&lang=js"
export * from "./DetailError.vue?vue&type=script&lang=js"
import style0 from "./DetailError.vue?vue&type=style&index=0&id=d077bf6e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports